<template>
  <!--begin::Menu-->
  <div
    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px"
    data-kt-menu="true"
  >
    <!--begin::Menu item-->
    <div class="menu-item px-3">
      <div class="menu-content d-flex align-items-center px-3">
        <!--begin::Avatar-->
        <div class="symbol symbol-50px me-5">
          <img
            alt="Logo"
            :src="
              userOnlineObj.AvatarUrl === null
                ? 'media/avatars/blank.png'
                : userOnlineObj.AvatarUrl
            "
          />
        </div>
        <!--end::Avatar-->

        <!--begin::Username-->
        <div class="d-flex flex-column">
          <div class="fw-bolder d-flex align-items-center fs-5">
            {{ `${userOnlineObj.FirstName} ${userOnlineObj.LastName}` }}
          </div>

          <a
            :href="`mailto:${userOnlineObj.Email}`"
            class="fw-bold text-muted text-hover-primary fs-7"
            style="
              width: 180px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            >{{ userOnlineObj.Email }}</a
          >
        </div>
        <!--end::Username-->
      </div>
    </div>

    <!-- <div class="menu-item px-5">
      <router-link to="/pages/profile/overview" class="menu-link px-5">
        My Profile
      </router-link>
    </div> -->

    <div class="separator my-2"></div>

    <!--begin::Menu item-->
    <div
      class="menu-item px-5"
      data-kt-menu-trigger="hover"
      data-kt-menu-placement="left-start"
      data-kt-menu-flip="center, top"
    >
      <a class="menu-link px-5">
        <span class="menu-title position-relative">
          {{ translate("Menu_Language_Setting") }}
          <span
            class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0"
          >
            {{ translate(currentLangugeLocale.name) }}
            <img
              class="w-15px h-15px rounded-1 ms-2"
              :src="currentLangugeLocale.flag"
              alt="metronic"
            />
          </span>
        </span>
      </a>

      <!--begin::Menu sub-->
      <div class="menu-sub menu-sub-dropdown w-175px py-4">
        <!--begin::Menu item-->
        <div class="menu-item px-3 mb-1">
          <a
            @click="setLang('en')"
            class="menu-link d-flex px-5"
            :class="{ active: currentLanguage('en') }"
          >
            <span class="symbol symbol-20px me-4">
              <img class="rounded-1" src="media/flags/en.svg" alt="metronic" />
            </span>
            {{ translate("English") }}
          </a>
        </div>

        <!--end::Menu item-->

        <!--begin::Menu item-->
        <div class="menu-item px-3">
          <a
            @click="setLang('tr')"
            class="menu-link d-flex px-5"
            :class="{ active: currentLanguage('tr') }"
          >
            <span class="symbol symbol-20px me-4">
              <img class="rounded-1" src="media/flags/tr.svg" alt="metronic" />
            </span>
            {{ translate("Turkish") }}
          </a>
        </div>
        <!--end::Menu item-->
      </div>
      <!--end::Menu sub-->
    </div>
    <!--end::Menu item-->

    <!--begin::Menu item-->
    <div class="menu-item px-5 my-1">
      <router-link to="/profile" class="menu-link px-5">
        {{ translate("account") }}
      </router-link>
    </div>
    <!--end::Menu item-->

    <!--begin::Menu item-->
    <div class="menu-item px-5">
      <a @click="signOut()" class="menu-link px-5">{{
        translate("signOut")
      }}</a>
    </div>
    <!--end::Menu item-->
  </div>
  <!--end::Menu-->
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
const router = useRouter();
const i18n = useI18n();
const store = useStore();

const userOnlineObj = computed(() => store.getters["AuthModule/_getUser"]);
i18n.locale.value = localStorage.getItem("lang")
  ? localStorage.getItem("lang")
  : "en";

const countries = {
  en: {
    flag: "media/flags/en.svg",
    name: "English",
    id: 1,
  },
  tr: {
    flag: "media/flags/tr.svg",
    name: "Turkish",
    id: 2,
  },
};

const signOut = () => {
  store.commit("AuthModule/LOG_OUT");
  router.push({ name: "sign-in" });
};

const setLang = (lang) => {
  store
    .dispatch("AuthModule/SET_USER_LANG", countries[lang].id)
    .then((response) => {
      if (response) {
        localStorage.setItem("lang", lang);
        i18n.locale.value = lang;
      }
    });
};

const currentLanguage = (lang) => {
  return i18n.locale.value === lang;
};

const currentLangugeLocale = computed(() => {
  return countries[i18n.locale.value];
});
</script>
